"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResponsePrismicByUID = exports.getLanguage = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _getPrismicDocumentLang = _interopRequireDefault(require("@deosite/helpers/getPrismicDocumentLang"));
var _getLanguageFromHostname = _interopRequireDefault(require("@deosite/helpers/getLanguageFromHostname"));
var _cache = require("@deosite/helpers/cache");
var _prismicConfiguration = require("./prismic-configuration");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var getLanguage = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var language, filename, currentLanguage, lang, cacheFilePath, cachedFilePrismic;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            language = _ref.language, filename = _ref.filename;
            currentLanguage = language ? language === null || language === void 0 ? void 0 : language.language : (0, _getLanguageFromHostname["default"])();
            lang = (0, _getPrismicDocumentLang["default"])(language ? language === null || language === void 0 ? void 0 : language.language : (0, _getLanguageFromHostname["default"])());
            cacheFilePath = "".concat(currentLanguage, "/");
            _context.next = 6;
            return readCacheFilePrismic({
              cacheFilePath: cacheFilePath,
              constantFileName: "".concat(filename)
            });
          case 6:
            cachedFilePrismic = _context.sent;
            return _context.abrupt("return", _objectSpread(_objectSpread({}, cachedFilePrismic), {}, {
              lang: lang,
              cacheFilePath: cacheFilePath
            }));
          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function getLanguage(_x) {
    return _ref2.apply(this, arguments);
  };
}();
exports.getLanguage = getLanguage;
var readCacheFilePrismic = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref3) {
    var cacheFilePath, constantFileName, _yield$readCacheFile, cacheFileExist, cachedRequest;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            cacheFilePath = _ref3.cacheFilePath, constantFileName = _ref3.constantFileName;
            _context2.next = 3;
            return (0, _cache.readCacheFile)({
              cacheFilePath: cacheFilePath,
              constantFileName: constantFileName,
              contextRequest: true,
              forPrismic: true
            });
          case 3:
            _yield$readCacheFile = _context2.sent;
            cacheFileExist = _yield$readCacheFile.cacheFileExist;
            cachedRequest = _yield$readCacheFile.cachedRequest;
            if (cacheFileExist) {
              cachedRequest = Object.values(cachedRequest).length ? cachedRequest : false;
            }
            return _context2.abrupt("return", {
              cacheFileExist: cacheFileExist,
              cachedRequest: cachedRequest
            });
          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function readCacheFilePrismic(_x2) {
    return _ref4.apply(this, arguments);
  };
}();
var getResponsePrismicByUID = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref5) {
    var uid, type, lang, _ref5$withPrefix, withPrefix;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            uid = _ref5.uid, type = _ref5.type, lang = _ref5.lang, _ref5$withPrefix = _ref5.withPrefix, withPrefix = _ref5$withPrefix === void 0 ? true : _ref5$withPrefix;
            _context3.next = 3;
            return (0, _prismicConfiguration.Client)().getByUID("".concat(withPrefix ? global.__appConfig__.prismicPrefix : "") + type, uid, {
              lang: lang
            });
          case 3:
            return _context3.abrupt("return", _context3.sent);
          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function getResponsePrismicByUID(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
exports.getResponsePrismicByUID = getResponsePrismicByUID;